import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, NavLink} from "react-router-dom";
import Fade from 'react-reveal/Fade';
import {BrowserView, MobileView, isBrowser, isMobile, isOpera, isIE} from 'react-device-detect';
import { Fullpage, Slide, HorizontalSlider } from 'fullpage-react';
import {Helmet} from 'react-helmet';
import CompPositions from './comp-positions.jsx';
import OpenPositions from './open-positions.jsx';

var className = 'customSelect'

class Landing extends Component {

  constructor (props) {
    super(props);

    this.state = {
      animate0: true,
      animate1: false,
      animate2: false,
      animate3: false
    };

    this.onSlideChangeStart = this.onSlideChangeStart.bind(this);
    this.onSlideChangeEnd = this.onSlideChangeEnd.bind(this);
  }

  componentDidMount() {

    var document = global.document;

    // removing overflow style from body when leaving landing page (allow for native scrolling).
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // hacky code for mobile browsers
    if(document.height < window.outerHeight) {
      document.body.style.height = (window.outerHeight + 50) + 'px';
    }

    var header = document.getElementById("navigation");
    header.classList.remove('active');
    header.style.top = "0";

    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'visible';
    document.body.style.overflow = 'visible';
  }

  onSlideChangeStart(name, props, state, newState) {

    switch(newState.activeSlide) {

      case 0:
        this.setState({
          animate0: true,
          animate1: false,
          animate2: false,
          animate3: false
        })
        break;

      case 1:
        this.setState({
          animate0: false,
          animate1: true,
          animate2: false,
          animate3: false
        })
        break;

      case 2:
        this.setState({
          animate0: false,
          animate1: false,
          animate2: true,
          animate3: false
        })
        break;

      case 3:
        this.setState({
          animate0: false,
          animate1: false,
          animate2: false,
          animate3: true
        })
        break;

      default:
    }
  }

  onSlideChangeEnd(name, props, state, newState) {

  }

  render() {

    const fullPageOptions = {
      // for mouse/wheel events
      // represents the level of force required to generate a slide change on non-mobile, 0 is default
      scrollSensitivity: 8,

      // for touchStart/touchEnd/mobile scrolling
      // represents the level of force required to generate a slide change on mobile, 0 is default
      touchSensitivity: 0,
      scrollSpeed: 500,
      resetSlides: true,
      hideScrollBars: true,
      enableArrowKeys: true,

      // optional, set the initial vertical slide
      activeSlide: 0
    };

    const slides = [
      <Slide>
        <div className="section-container one" name="this-is-us" id="this-is-us" id="section">
          <Fade duration={1000} delay={0} when={this.state.animate0} appear>
            <div className="bg this-is-us" id="this-is-us-BG">
              <BrowserView device={isBrowser}>
                <div className="video-background">
                  <div className="video-container">
                    <video className="background-video" loop autoPlay muted>
                      <source src="/videos/universe.mp4" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </BrowserView>
              <MobileView device={isMobile}>
                <div className="bg this-is-us mobile"></div>
              </MobileView>
            </div>
          </Fade>
          <Fade duration={400} delay={650} when={this.state.animate0} bottom cascade appear>
            <div className="content">
              <h1 className="section-subheading-landing">Welcome to bethard universe</h1>
              <div className="section-heading">this is the result of organized chaos</div>
              <NavLink className="button-link" to="/page/this-is-us" activeClassName="selected">Read more</NavLink>
            </div>
          </Fade>
          <div className="icon-scroll"></div>
        </div>
      </Slide>,

      <Slide>
        <div className="section-container two" name="work-at-bethard" id="work-at-bethard" id="section">
          <Fade duration={1000} delay={0} when={this.state.animate1}>
            <div className="bg work-at-bethard" id="work-at-bethard-BG">
              <BrowserView device={isBrowser}>
                <div className="video-background">
                  <div className="video-container">
                    <video className="background-video" loop autoPlay muted>
                      <source src="/videos/workatbethard2.mp4" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </BrowserView>
              <MobileView device={isMobile}>
                <div className="bg work-at-bethard mobile"></div>
              </MobileView>
            </div>
          </Fade>
          <Fade duration={400} delay={650} when={this.state.animate1} bottom cascade>
            <div className="content">
              <div className="title-number">
                <div className="number">02</div>
                <h2 className="section-subheading"><a href="/page/work-at-bethard">Work at bethard</a></h2>
              </div>
              <div className="context">
                <div className="section-heading">Working together</div>
                <div className="section-heading">to challenge old</div>
                <div className="section-heading">ideas</div>
                <NavLink className="section-more-link" to="/page/work-at-bethard" activeClassName="selected">Read more <i className="fas fa-arrow-right"></i></NavLink>
              </div>
            </div>
          </Fade>
          <div className="icon-scroll"></div>
        </div>
      </Slide>,

      <Slide>
        <div className="section-container three" name="meet-the-people" id="meet-the-people" id="section">
          <Fade duration={1000} delay={0} when={this.state.animate2}>
            <div className="bg meet-the-people" id="meet-the-people-BG">
              <BrowserView device={isBrowser}>
                <div className="video-background">
                  <div className="video-container">
                    <video className="background-video" loop autoPlay muted>
                      <source src="/videos/meet_landing.mp4" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </BrowserView>
              <MobileView device={isMobile}>
                <div className="bg meet-the-people mobile"></div>
              </MobileView>
            </div>
          </Fade>
          <Fade duration={400} delay={650} when={this.state.animate2} bottom cascade>
            <div className="content">
              <div className="title-number">
                <div className="number">03</div>
                <h2 className="section-subheading"><a href="/page/meet-the-people">Meet the people</a></h2>
              </div>
              <div className="context">
                <div className="section-heading">The Universe</div>
                <div className="section-heading">is about the</div>
                <div className="section-heading">people</div>
                <NavLink className="section-more-link" to="/page/meet-the-people" activeClassName="selected">Read more <i className="fas fa-arrow-right"></i></NavLink>
              </div>
            </div>
          </Fade>
          <div className="icon-scroll"></div>
        </div>
      </Slide>,

      <Slide>
        <div className="section-container four" name="open-positions" id="open-positions" id="section">
          <Fade duration={1000} delay={0} when={this.state.animate3} appear>
            <div className="bg open-positions" id="open-positions-BG">
              <BrowserView device={isBrowser}>
                <div className="bg open-positions"></div>
              </BrowserView>
              <MobileView device={isMobile}>
                <div className="bg open-positions mobile"></div>
              </MobileView>
            </div>
          </Fade>
          <Fade duration={400} delay={650} when={this.state.animate3} bottom cascade appear>
            <div className="content">
              <h1 className="section-subheading-landing">Join the team</h1>
              <div className="section-heading">Become part of the universe</div>
              <NavLink className="button-link" to="/page/career" activeClassName="selected">See open positions</NavLink>
            </div>
          </Fade>
        </div>
      </Slide>
    ];

    fullPageOptions.slides = slides;

    if(!isOpera && !isIE) {
      return (
        <div className="landing-wrapper">

          <Helmet>
            <title>Bethard Universe</title>
            <link rel="canonical" href={location.protocol + '//' + location.host} />
            <meta property="og:title" content="Bethard Universe" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={location.href} />
            <meta property="og:image" content={location.protocol + '//' + location.host + '/img/us_single.jpg'} />
          </Helmet>

          <Fullpage onSlideChangeStart={this.onSlideChangeStart} onSlideChangeEnd={this.onSlideChangeEnd} {...fullPageOptions} />

          <div className="landing-awards">
            <img src='/img/BHU_Awards.png' identifier="this-is-us"/>
          </div>
        </div>
      );
    }

    if(isIE) {
      return (
        <div className="landing-wrapper">
          <Helmet>
            <title>Bethard Universe</title>
            <link rel="canonical" href={location.protocol + '//' + location.host} />
            <meta property="og:title" content="Bethard Universe" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={location.href} />
            <meta property="og:image" content={location.protocol + '//' + location.host + '/img/us_single.jpg'} />
          </Helmet>

          <div className="section-container one ie" name="this-is-us" id="this-is-us">
            <Fade duration={1000} delay={0} when={this.state.animate0} appear>
              <div className="bg this-is-us" id="this-is-us-BG">
                <video className="background-video" loop autoPlay muted>
                  <source src="/videos/universe.mp4" type="video/mp4" />
                </video>
              </div>
            </Fade>
            <Fade duration={400} delay={200} when={this.state.animate0} bottom cascade appear>
              <div className="content">
                <h1 className="section-subheading-landing">Welcome to bethard universe</h1>
                <div className="section-heading">this is the result of organized chaos</div>
                <NavLink className="button-link" to="/page/this-is-us" activeClassName="selected">Read more</NavLink>
              </div>
            </Fade>
          </div>

          <div className="landing-awards">
            <img src='/img/BHU_Awards.png' identifier="this-is-us"/>
          </div>

        </div>
      );
    }

    if(isOpera) {
      return (
        <div className="landing-wrapper">
          <Helmet>
            <title>Bethard Universe</title>
            <link rel="canonical" href={location.protocol + '//' + location.host} />
            <meta property="og:title" content="Bethard Universe" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={location.href} />
            <meta property="og:image" content={location.protocol + '//' + location.host + '/img/us_single.jpg'} />
          </Helmet>

          <div className="section-container one" name="this-is-us" id="this-is-us">
            <Fade duration={1000} delay={0} when={this.state.animate0} appear>
              <div className="bg this-is-us" id="this-is-us-BG">
                <video className="background-video" loop autoPlay muted>
                  <source src="/videos/universe.mp4" type="video/mp4" />
                </video>
              </div>
            </Fade>
            <Fade duration={400} delay={200} when={this.state.animate0} bottom cascade appear>
              <div className="content">
                <h1 className="section-subheading-landing">Welcome to bethard universe</h1>
                <div className="section-heading">this is the result of organized chaos</div>
                <NavLink className="button-link" to="/page/this-is-us" activeClassName="selected">Read more</NavLink>
              </div>
            </Fade>
          </div>

          <div className="landing-awards">
            <img src='/img/BHU_Awards.png' identifier="this-is-us"/>
          </div>

        </div>
      );
    }
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./client/components/landing.jsx